import { numberOfChipsEnum } from '../config/form';

/**
 * Chips Destribution Collection Data
 * @typedef {Array.<ChipData>}
 * @typedef ChipData
 * @property {String} color - Chip color
 * @property {Number} quantity - Quantity of current chip
 * @property {Number} value - Value of current chip
 */
const destributionArray = [
    [
        { color: 'blue', quantity: 8, value: 25 },
        { color: 'red', quantity: 10, value: 50 },
        { color: 'green', quantity: 3, value: 100 },
    ],
    [
        { color: 'blue', quantity: 8, value: 25 },
        { color: 'red', quantity: 8, value: 50 },
        { color: 'green', quantity: 4, value: 100 },
        { color: 'purple', quantity: 5, value: 200 },
    ],
    [
        { color: 'blue', quantity: 10, value: 100 },
        { color: 'red', quantity: 10, value: 200 },
        { color: 'green', quantity: 2, value: 500 },
        { color: 'purple', quantity: 1, value: 1000 },
    ],
    [
        { color: 'blue', quantity: 10, value: 100 },
        { color: 'red', quantity: 5, value: 200 },
        { color: 'green', quantity: 4, value: 500 },
        { color: 'purple', quantity: 2, value: 1000 },
        { color: 'orange', quantity: 2, value: 2000 },
    ],
    [
        { color: 'blue', quantity: 8, value: 250 },
        { color: 'red', quantity: 6, value: 500 },
        { color: 'green', quantity: 5, value: 1000 },
        { color: 'purple', quantity: 3, value: 5000 },
    ],
    [
        { color: 'blue', quantity: 8, value: 250 },
        { color: 'red', quantity: 6, value: 500 },
        { color: 'green', quantity: 5, value: 1000 },
        { color: 'purple', quantity: 8, value: 5000 },
    ],
];

/**
 * Map chips collection with the corresponding numberOfChip value
 * @typedef {Map.<NumberOfChip, ChipData>}
 */
const chipsEntries = Object.values(numberOfChipsEnum)
    .reduce(
        (entriesArray, chipNumber, chipIndex) => [
            ...entriesArray,
            [
                chipNumber,
                destributionArray[chipIndex]
            ] 
        ]
    , []);
const chipsMap = new Map(chipsEntries);

/**
 * Collection of payouts
 * @typedef {Array.<PayoutObj>}
 * @typedef PayoutObj
 * @property {Object.<Number, Number>} rangeOfPlayers 
 * - min and max amount of players for this payout
 * @property {Array.<Number>} prizePoolPercentages 
 * - prize percentages for this payout
 */
const payoutsCollection = [
    {
        rangeOfPlayers: { min: 1, max: 12 },
        prizePoolPercentages: [50.0, 30.0, 20.0],
    },
    {
        rangeOfPlayers: { min: 13, max: 20 },
        prizePoolPercentages: [45.0, 30.0, 15.0, 10.0],
    },
    {
        rangeOfPlayers: { min: 21, max: 30 },
        prizePoolPercentages: [40.0, 27.0, 15.0, 10.0, 8.0],
    },
    {
        rangeOfPlayers: { min: 31, max: 40 },
        prizePoolPercentages: [37.0, 25.0, 15.0, 10.0, 7.5, 5.5],
    },
    {
        rangeOfPlayers: { min: 41, max: 50 },
        prizePoolPercentages: [35.0, 22.5, 15.0, 10.0, 7.5, 5.5, 4.5],
    },
    {
        rangeOfPlayers: { min: 51, max: 60 },
        prizePoolPercentages: [32.0, 21.0, 15.0, 10.1, 7.6, 5.6, 4.6, 4.1],
    },
];
/**
 * Last and first payout obj to get min/max amount of players to handle
 */
const firstPayoutObj = payoutsCollection[0];
const lastPayoutObj = payoutsCollection[payoutsCollection.length - 1];

export {
    chipsMap,
    payoutsCollection,
    firstPayoutObj,
    lastPayoutObj
}